import { render, staticRenderFns } from "./CrearPaquete.vue?vue&type=template&id=84d43598&scoped=true"
import script from "./CrearPaquete.vue?vue&type=script&lang=js"
export * from "./CrearPaquete.vue?vue&type=script&lang=js"
import style0 from "./CrearPaquete.vue?vue&type=style&index=0&id=84d43598&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84d43598",
  null
  
)

export default component.exports